import { ProductMeta, SplitColor } from '@proto/store/api/common/common';
import { Urls } from '@helper/urls';
import { Favorite } from '@proto/store/api/store/misc/favorite/favorite';
import { StockReminder } from '@proto/store/api/store/misc/stock_reminder/stock_reminder';

export class FavoriteProduct {
  constructor(
    public productId: string,
    public skuId: string,
    public image: string,
    public link: string,
    public meta: ProductMeta | undefined,
    public published: boolean,
    public colors: SplitColor[],
    public colorId: string,
    public colorSizeName: string,
    public promotionName: string,
    public isArrival: boolean
  ) {}
  static favoriteToProducts(favorites: Favorite[] | undefined): FavoriteProduct[] | undefined {
    return favorites?.map(
      fav =>
        new FavoriteProduct(
          fav.item?.meta?.productId ?? '',
          '',
          fav.image,
          Urls.fromMeta(fav.item?.meta, ''),
          fav.item?.meta,
          fav.published,
          fav.item?.colors ?? [],
          '',
          '',
          fav.promotion?.name ?? '',
          false
        )
    );
  }

  static reminderToProducts(reminders: StockReminder[] | undefined): FavoriteProduct[] | undefined {
    return reminders?.map(
      rem =>
        new FavoriteProduct(
          '',
          rem.skuId,
          rem.image,
          Urls.fromSkuId(rem.skuId),
          rem.meta,
          rem.published,
          [],
          '',
          `${rem.colorName} - ${rem.sizeName}`,
          '',
          rem.inventory > 0
        )
    );
  }
}
